import { Container, Header, Icon, Segment } from '@mairistem/composants';
import type React from 'react';
import { estEncaissementTermine } from '@/utils';

interface EmbeddedHandlerProps {
  children: React.ReactNode;
}

/** Message "Encaissement terminé" réutilisable */
export const EncaissementTermineMessage = () => (
  <Container fluid style={{ paddingTop: 100, alignItems: 'center' }}>
    <Segment
      basic
      textAlign="center"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Header icon size="large" color="green">
        <Icon name="check circle" size="massive" color="green" />
        Encaissement terminé.
        <br />
        <br />
        <Header.Subheader>Vous pouvez fermer cet onglet.</Header.Subheader>
      </Header>
    </Segment>
  </Container>
);

const EmbeddedHandler = ({ children }: EmbeddedHandlerProps) => {
  // Si l'encaissement est terminé, afficher le message et ne pas rendre les enfants
  if (estEncaissementTermine()) {
    return <EncaissementTermineMessage />;
  }

  return children;
};

export default EmbeddedHandler;
